import { CfFaqDetailPreview } from "types/pages/types";
import { FaqDetailPreview } from "types/faqs/types";
import { FaqListPreviewProps } from "components/FaqListPreview/types";
import { getFaqBySlug } from "./getFaqBySlug";
import { logDebug } from "helpers/generic";
import React from "react";

interface RecursiveData {
  // TODO: ts when resolve template
  data: any;
  typename: string;
  faqs: CfFaqDetailPreview[];
}

interface UpdateFaqPreview {
  item: FaqListPreviewProps;
  allFaqs: FaqDetailPreview[];
}

interface CheckNested {
  element: any;
  typename: string;
  faqs: FaqDetailPreview[];
}

const updateFaqPreview = ({ item, allFaqs }: UpdateFaqPreview) => {
  // @ts-expect-error ModFaqDetailPreview
  item.faqs = getFaqBySlug({
    nodeLocale: item.node_locale,
    arraySlug: item.list,
    allFaqs,
  });
  return item;
};

const checkNested = ({ element, typename, faqs }: CheckNested) => {
  // eslint-disable-next-line no-underscore-dangle
  if (element.__typename === typename) {
    element = updateFaqPreview({ item: element, allFaqs: faqs });
  } else if (element.content && Array.isArray(element.content)) {
    // TODO: ts resolve when all components are done
    // @ts-expect-error
    element.content.map((el) => {
      return checkNested({ element: el, typename, faqs });
    });
  }
  logDebug("element ", element);
  return element;
};

const recursiveData = ({ data, typename, faqs }: RecursiveData) => {
  if (Array.isArray(data)) {
    return data.map((element) => {
      const el = checkNested({ element, typename, faqs });
      return el;
    });
  }
  return data;
};

export default recursiveData;
